import { render, staticRenderFns } from "./CheckboxControl.vue?vue&type=template&id=60d1e43e"
import script from "./CheckboxControl.vue?vue&type=script&lang=js"
export * from "./CheckboxControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports